import React from 'react'

function CategorieNotFound() {
    return (



        <div className="flex flex-col justify-center items-center h-screen p-64">
            <h1 className="text-3xl font-bold mb-4">Search Result Empty</h1>
            <p className="text-lg text-gray-600">The Category/Product you're looking for does not exist.</p>
        </div>


    )
}

export default CategorieNotFound